import { writable } from "svelte/store";

export let jurisdictionTableFilter = writable(null);
